import { DARK_MODE, LIGHT_MODE } from "../constants"

const initialState = {
    isDarkMode: true
}

export const darkModeReducer = (state = initialState, action) => {
    switch (action.type) {
        case DARK_MODE:
            return { ...state, isDarkMode: true }
        case LIGHT_MODE:
            return { ...state,  isDarkMode: false }
        default: return state
    }
}